const { pathToRegexp, compile } = require('path-to-regexp')
const urlModule = require('url')
const { parse } = urlModule

class Routes {
  constructor() {
    this.routes = []
  }

  add(name, pattern, page) {
    const options = { name, pattern: pattern || `/${name}`, page: page || name }
    if (this.findByName(name)) {
      throw new Error(`Route "${name}" already exists`)
    }
    this.routes.push(new Route(options))
    return this
  }

  findByName(name) {
    return this.routes.find(route => route.name === name)
  }

  match(url) {
    const parsedUrl = parse(url, true)
    const { pathname, query } = parsedUrl

    for (const route of this.routes) {
      const params = route.match(pathname)
      if (params) {
        return {
          parsedUrl,
          route,
          params,
          query: { ...query, ...params },
        }
      }
    }
    return { query, parsedUrl }
  }

  getRewritesEntries() {
    const entries = []
    for (const route of this.routes) {
      if (route.pattern !== route.page) {
        entries.push({
          source: route.pattern,
          destination: route.page,
        })
      }
    }
    return entries
  }

  getRouteList() {
    return this.routes.map(route => route.pattern)
  }
}

class Route {
  constructor({ name, pattern, page }) {
    this.name = name
    this.pattern = pattern
    this.page = page.replace(/(^|\/)index$/, '').replace(/^\/?/, '/')

    const { keys, regexp } = pathToRegexp(this.pattern)
    this.regex = regexp
    this.keys = keys
    this.keyNames = this.keys.map(key => key.name)
    this.toPath = compile(this.pattern)
  }

  match(path) {
    const values = this.regex.exec(path)
    if (values) {
      return this.valuesToParams(values.slice(1))
    }
    return null
  }

  valuesToParams(values) {
    return values.reduce((params, val, i) => {
      if (val === undefined) {
        return params
      }
      return Object.assign(params, {
        [this.keys[i].name]: decodeURIComponent(val),
      })
    }, {})
  }
}

module.exports = () => new Routes()
